import { loadBricksImperatively } from "@next-core/loader";
import { getBrickPackages, getRuntime, hooks } from "./internal/Runtime.js";
import { omit } from "lodash";
let brick;
export const WATEMARK_BRICKNAME = "basic.show-watermark";
export function setWatermark() {
  var _window$APP_ROOT, _window$APP_ROOT2, _username, _hooks$auth, _settings$watermarkCo, _watermarkConfig$cont, _watermarkConfig$flag, _watermarkConfig$flag2;
  const flags = getRuntime().getFeatureFlags();
  const settings = getRuntime().getMiscSettings();
  if (!flags["show-watermark"]) {
    return;
  }
  const isDeveloper = ((_window$APP_ROOT = window.APP_ROOT) === null || _window$APP_ROOT === void 0 || (_window$APP_ROOT = _window$APP_ROOT.match(/versions\/([^/]+)\//)) === null || _window$APP_ROOT === void 0 ? void 0 : _window$APP_ROOT[1]) === "0.0.0" || ((_window$APP_ROOT2 = window.APP_ROOT) === null || _window$APP_ROOT2 === void 0 || (_window$APP_ROOT2 = _window$APP_ROOT2.match(/micro-apps\/(?:v2|v3)\/[^/]+\/([^/]+)/)) === null || _window$APP_ROOT2 === void 0 ? void 0 : _window$APP_ROOT2[1]) === "0.0.0";
  const username = (_username = hooks === null || hooks === void 0 || (_hooks$auth = hooks.auth) === null || _hooks$auth === void 0 || (_hooks$auth = _hooks$auth.getAuth()) === null || _hooks$auth === void 0 ? void 0 : _hooks$auth.username) !== null && _username !== void 0 ? _username : "";
  const watermarkConfig = (_settings$watermarkCo = settings.watermarkConfig) !== null && _settings$watermarkCo !== void 0 ? _settings$watermarkCo : {
    flags: {}
  };
  const content = [...(typeof watermarkConfig.content === "string" ? [watermarkConfig.content] : (_watermarkConfig$cont = watermarkConfig.content) !== null && _watermarkConfig$cont !== void 0 ? _watermarkConfig$cont : []), (_watermarkConfig$flag = watermarkConfig.flags) !== null && _watermarkConfig$flag !== void 0 && _watermarkConfig$flag["show-development"] && isDeveloper ? "Development" : "", (_watermarkConfig$flag2 = watermarkConfig.flags) !== null && _watermarkConfig$flag2 !== void 0 && _watermarkConfig$flag2["show-user"] ? username : ""].filter(Boolean);

  // Do not call showWatermark if there is no content
  if (content.length === 0) {
    return;
  }
  const defaultProps = {
    content,
    zIndex: 1001,
    width: 200,
    font: {
      fontSize: 28
    },
    gap: [190, 190],
    ...omit(watermarkConfig, ["content", "flags"])
  };
  if (brick) {
    brick.resolve(defaultProps);
  } else {
    loadBricksImperatively([WATEMARK_BRICKNAME], getBrickPackages()).then(() => {
      brick = document.createElement(WATEMARK_BRICKNAME);
      brick.resolve(defaultProps);
    },
    // istanbul ignore next
    error => {
      // eslint-disable-next-line no-console
      console.error("Load watermark service failed:", error);
    });
  }
}
//# sourceMappingURL=setWatermark.js.map